module.exports = __webpack_public_path__ + "img/imgQRcode.d03a34ba.png";